module.exports = __webpack_public_path__ + "static/illustration_security-32b500f52f8e85e62c45386f0c5df8c9.svg";